import type { ReactNode } from 'react'
import MFAccordion from '../../../../../../components/ui-components/MFAccordion'
import { BorderWithPadding } from './BorderWithPadding'

type BucketAccordionProps = {
  title: string
  count: number
  isExpanded: boolean
  onToggle: () => void
  children: ReactNode
  isBorderTop?: boolean
  bucketCompositeKey?: string
  bodyContentClassName?: string
}

export function BucketAccordion({
  title,
  count,
  isExpanded,
  onToggle,
  isBorderTop,
  bucketCompositeKey,
  children,
  bodyContentClassName = 'flex flex-col gap-5 pt-1 pb-5'
}: BucketAccordionProps) {
  return (
    <div className="flex flex-col w-[100%]" data-plan-category-bucket-key={bucketCompositeKey}>
      {isBorderTop ? <BorderWithPadding padding="pl-[69px]" /> : null}
      <MFAccordion
        title={title}
        iconComponent={<div className={`w-[32px] h-[24px] rounded-[10px] flex items-center 
      justify-center ${'bg-[#EBF2F2] text-[#232323]'}`}>
          <div className='-mt-[1px] text-[14px] text-center leading-[24px] font-[500]'>
            {count}
          </div>
        </div>}
        isExpanded={isExpanded}
        onAccordionClick={() => {
          onToggle()
        }}
        scrollOnExpand={false}
        accordionHeaderClassName="!min-h-[52px] !pt-5 !pb-6 !px-5"
        accordionBodyClassName="!px-0 !pb-0"
        chevronTopPadding='5px'
      >
        <div className={bodyContentClassName}>{children}</div>
      </MFAccordion>
    </div>
  )
}
